module.exports = __webpack_public_path__ + "static/media/ic-document.0af87cb9.svg";